import { render, staticRenderFns } from "./LdDialog.vue?vue&type=template&id=c79d4274&lang=pug"
import script from "./LdDialog.vue?vue&type=script&lang=js"
export * from "./LdDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports